import React from 'react';
import { css } from 'styled-components';
import { Heading } from '../../../..';
import displateTheme from '../../../../theme/displate/theme';
import { HeadingSizeType } from '../../../Atoms/Heading/Heading.enum';
import BaseSelectListItem from '../BaseComponents/BaseInputSelectListItem';
import BaseInputTextContainer from '../BaseComponents/BaseInputTextContainer';
const customizeInputSelectVisuals = () => css `
  position: relative;
  ${BaseInputTextContainer} {
    cursor: pointer;
    font-weight: 600;

    svg {
      transition: transform 0.3s ease;
    }

    &.active svg {
      z-index: 1001;
      transform: rotate(180deg);
    }
  }
`;
const createClonesOfChildren = (childrenArr, handler) => childrenArr.map((child) => {
    if (React.isValidElement(child)) {
        return React.cloneElement(child, {
            onClick: handler(child),
            'data-value': child.props.value,
            value: undefined,
            inactive: child.props.inactive,
            role: 'option',
            additionalInfo: child.props.additionalInfo,
            className: child.props.inactive ? 'inactive' : '',
        });
    }
    console.error('This is not valid React Element');
    return null;
});
const createChoices = (choices) => choices.map((choice) => React.createElement(BaseSelectListItem, { value: choice.value, key: choice.label, inactive: choice.inactive }, React.createElement(Heading, { as: 'span', textSize: HeadingSizeType.TITLE16 }, choice.label), choice.additionalInfo &&
    React.createElement(Heading, { as: 'span', textSize: HeadingSizeType.TITLE16, color: displateTheme.colors.disabled03 }, choice.additionalInfo)));
const getLabelFromValue = (selectedValue, items) => {
    if (selectedValue) {
        const autofilled = items.find((item) => item.props['data-value'] === selectedValue);
        if (autofilled)
            return autofilled.props.children;
    }
    return null;
};
export { createChoices, createClonesOfChildren, customizeInputSelectVisuals, getLabelFromValue };
//# sourceMappingURL=InputSelect.helpers.js.map